import { useEffect, useRef } from 'react';

import { getTypeOrNull } from '@spotify/confidence-graphql';

import { WorkflowInstance } from '../useGetWorkflowInstance';
import { useWorkflowTransitionInfo } from '../useWorkflowTransitionInfo';
import {
  WorkflowTransitionProgress,
  getWorkflowTransitionProgress,
} from './getWorkflowTransitionProgress';

export const useWorkflowTransitionProgress = (
  workflowInstance: WorkflowInstance,
): WorkflowTransitionProgress | null => {
  const lastStepProgress = useRef<WorkflowTransitionProgress | null>(null);
  const isTransitioning = !!getWorkflowTransitionProgress(workflowInstance);
  const workflowVersionName = getTypeOrNull(
    workflowInstance.workflowVersion,
  )?.name;

  const { workflowVersion } = useWorkflowTransitionInfo({
    name: workflowVersionName ?? '',
    skip: !isTransitioning || !workflowVersionName,
  });

  const progress = getWorkflowTransitionProgress(
    workflowInstance,
    workflowVersion?.workflowInfo,
    lastStepProgress.current,
  );
  const hasSteps = !!workflowInstance.pendingTransition;

  useEffect(() => {
    if (hasSteps) lastStepProgress.current = progress;
  }, [hasSteps, progress]);

  return progress;
};
